// Angular
import { Component, Input, OnInit, Injector } from '@angular/core';
// RxJS
import { Observable } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import { currentUser, Logout, User } from '../../../../../core/auth';
import { AppComponentBase } from '../../../../../../shared/app-component-base';
import { AppAuthService } from '../../../../../../shared/auth/app-auth.service';
import { AfterViewInit } from '@angular/core';

export class ProfileMenu  {
	icon : string
	title : string
	subtitle : string
	navigateUrl: string
	auth: boolean 
}

@Component({
	selector: 'kt-user-profile3',
	templateUrl: './user-profile3.component.html',
	styleUrls: ['./user-profile3.component.scss']
})
export class UserProfile3Component extends AppComponentBase implements OnInit {
	// Public properties
	user$: Observable<User>;
	userFullName : string ;
	userName : string;
	userCopmany : string;
	profileMenuItems: ProfileMenu[] = [];
	pendingRequestsAuthorization: boolean = null;
	clientLogo : string = '' ;

	@Input() avatar = true;
	@Input() greeting = true;
	@Input() badge: boolean;
	@Input() icon: boolean;

	/**
	 * Component constructor
	 *
	 * @param store: Store<AppState>
	 */
	constructor(
		private store: Store<AppState>,
		injector: Injector,
		private _authService : AppAuthService
       
	) {

			super(injector);


	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		// console.log("user-profile3.components APPSESSION");
		// console.log("AppSession", this.appSession);

		//Buraya arkadan sessin içerisinde gelen isAprrove property si eklenecek
		this.pendingRequestsAuthorization = true;

		this.userFullName =  this.appSession.user.name + ' ' + this.appSession.user.surname;  //"Hasan AKYÜZ"; //this.appSession.getShownLoginName();
		this.userName = this.appSession.user.userName
		this.userCopmany = this.appSession.user.defaultCustomerName;
		this.clientLogo = this.appSession.user.defaultCustomerName + '.png';
		//this.userFullName =  this.appSession.getShownLoginName();
		//this.userFullName =  this.appSession.getShownLoginName();


		// console.log('SESSION BURADA	');
		// console.log(this.appSession);
		
		//this.user$ = this.store.pipe(select(currentUser));
		
		this.profileMenuItems = [
			{ icon: "flaticon2-gear", title: "Profilim", subtitle: "Hesabınızı yönetin...", navigateUrl: "/app/traspop/profile", auth: true },
			{ icon: "flaticon2-gear", title: "Favori Ürünlerim", subtitle: "Favori ürünlerinizi yönetin.", navigateUrl: "/app/traspop/product/favorites", auth: true },
			{ icon: "flaticon2-gear", title: "Taleplerim", subtitle: "Yaptığınız POSM taleplerinin durumlarını takip...", navigateUrl: "/app/order/approve/1", auth: true },
			{ icon: "flaticon2-gear", title: "Onayımı Bekleyen Talepler", subtitle: "Onayınızı bekleyen taleplere göz atın.", navigateUrl: "/app/order/approve/0", auth: this.pendingRequestsAuthorization },

		];
		
	}

	

	/**
	 * Log out
	 */
	logout() {
		//this.store.dispatch(new Logout());
		this._authService.logout();
	}
}
